import React from 'react'
import Admin from '../Components/AdminDashbord/Admin/Admin'

const AdminPage = () => {
  return (
    <>
    <Admin/>
    </>
  )
}

export default AdminPage
